import { useEffect, useState, useCallback, useRef } from 'react';
// import * as Sentry from '@sentry/browser';
import PT from 'prop-types';
import AX from 'axios';
import { BlockSpinner } from '../helpers/Spiners';
import { responceImageToB64 } from '../helpers';
import axios from '../_actions/axiosInstance';
import SRC404 from '../assets/images/errors/404-page.svg';
import SRC500 from '../assets/images/errors/500-page.svg';
import SRC502 from '../assets/images/errors/502-error.svg';

const errors = {
  404: SRC404,
  500: SRC500,
  504: SRC500,
  503: SRC500,
  502: SRC502,
  null: SRC404,
  undefined: SRC404,
  false: SRC404
};

const AsyncImage = ({ url, alt, style, showImage, finishCallback }) => {
  const reqToken = useRef();
  const [src, setSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const generateImage = useCallback(async () => {
    setLoading(true);
    let newSrc;
    try {
      const res = await axios.get(url, {
        responseType: 'arraybuffer',
        cancelToken: reqToken.current.token
      });
      newSrc = responceImageToB64(res);
    } catch (e) {
      // Sentry.captureException(e);
      newSrc = errors[e?.response?.status];
    }
    setSrc(newSrc);
    finishCallback();
    setLoading(false);
  }, [url]);

  useEffect(() => {
    if (url) {
      reqToken.current = AX.CancelToken.source();
      generateImage();
    }
    return () => {
      if (reqToken?.current?.cancel) {
        reqToken.current.cancel('Cancelling in cleanup');
      }
    };
  }, [url, generateImage]);

  if (typeof src === 'boolean') {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <div className="d-flex align-content-center image-loader" onClick={showImage}>
        Server Error
      </div>
    );
  }

  if (loading) {
    return (
      <div className="d-flex align-content-center image-loader">
        <BlockSpinner />
      </div>
    );
  }
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
  return <img src={src} alt={alt} style={style} onClick={showImage} />;
};

AsyncImage.propTypes = {
  url: PT.string.isRequired,
  alt: PT.string,
  style: PT.instanceOf(Object),
  showImage: PT.func,
  finishCallback: PT.func
};

AsyncImage.defaultProps = {
  alt: '',
  style: {},
  showImage: () => {},
  finishCallback: () => {}
};

export default AsyncImage;
